import { render } from "./PhotosView.vue?vue&type=template&id=bd0f869e"
import script from "./PhotosView.vue?vue&type=script&lang=js"
export * from "./PhotosView.vue?vue&type=script&lang=js"

import "./PhotosView.vue?vue&type=style&index=0&id=bd0f869e&scope=true&lang=css"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__